var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag_en_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h24v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.903-2.166 2.06 3.429-28.287 16.996-2.06-3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2844",
    d: "m25.414-1.308 1.03 1.714-28.287 16.996-1.03-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.96 14.83-2.06 3.43L-3.386 1.262l2.06-3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2844",
    d: "m26.446 15.687-1.03 1.714L-2.872.405l1.03-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.504-1h6v18h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.496 5h25v6h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2844",
    d: "M-.496 6h25v4h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2844",
    d: "M9.504-1h4v18h-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag_en_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
};
export default SvgFlagEn;